export default "__VITE_ASSET__C035wqql__"